import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { route } from 'preact-router';

import style from './style.css';

const initialState = {};

@observer
class TagLine extends Component {
    render() {
        const { tag, queryFilter, onClickTag, children, parent, className } = this.props;
        const isSelected = queryFilter.tag === tag.id || parent === tag.id;
        return (
            <div class='nav-item'>
                <div class={`${style.pointerCursor} nav-link py-0 ${isSelected ? 'active' : ''} ${className}`}>
                    <span onClick={() => onClickTag(tag.id, { open: !tag.parent })}>
                        <small class='float-right'>
                            {tag.filter ? <i class='fas fa-filter ml-1' /> : ''}
                            {tag.menu ? <i class='fas fa-bars ml-1' /> : ''}
                            {tag.pinned ? <i class='fas fa-thumbtack ml-1' /> : ''}
                        </small>
                        <i class={`fas fa-folder${isSelected ? '-open' : ''} mr-1`} />
                        {tag.name}
                        {tag.count && <span class='font-weight-lighter ml-2'>({tag.count})</span>}
                    </span>
                </div>
                {isSelected && <div class={`d-${isSelected ? 'block' : 'none'} nav flex-column mt-1 ml-4`}>
                    <TagList
                        className={className}
                        tags={children}
                        queryFilter={queryFilter}
                        onClickTag={onClickTag}
                        parent={parent}
                    />
                </div>}
            </div>
        );
    }
}

@observer
class TagList extends Component {
    render() {
        const { tags, queryFilter, onClickTag, children, parent, className } = this.props;
        return (
            <div>
                {tags.map(tag => <TagLine
                    className={className}
                    tag={tag}
                    queryFilter={queryFilter}
                    onClickTag={onClickTag}
                    children={children}
                    parent={parent}
                />)}
            </div>
        );
    }
}

@observer
class TagTree extends Component {
    constructor(props) {
        super(props);
        this.state = { ...initialState };

        const { tagStore } = this.props.stores;
        const { tagTreeParent } = tagStore;
        tagStore.load('', false, { dataKey: 'tagTree', query: { hasParent: 0 } });
        tagStore.load('', false, { dataKey: 'tagTreeBranchPinned', query: { pinned: 1 } });
        if (tagTreeParent) {
            tagStore.load('', false, { dataKey: 'tagTreeBranch', query: { parent: tagTreeParent, limit: 200 } });
        }
    }

    onClickTag = (id, opt = {}) => {
        const { articleStore } = this.props.stores;
        articleStore.toggleQueryfilter('tag', id, { setValue: true });
        if (opt.open) {
            const { tagStore } = this.props.stores;
            tagStore.updateKeyValue('tagTreeBranch', []);
            tagStore.updateKeyValue('tagTreeParent', id, { save: true });
            tagStore.load('', false, { dataKey: 'tagTreeBranch', query: { parent: id, limit: 200 } });
        }
    }

    render(props = this.props) {
        const { tagStore, articleStore } = props.stores;
        const { tagTree, tagTreeBranch, tagTreeBranchPinned, tagTreeParent } = tagStore;
        const { queryFilter } = articleStore;
        const isSelected = !queryFilter.tag;

        return (
            <div class='nav flex-column nav-pills'>
                <div class='nav-item mb-4 pb-4' style='border-bottom: 1px solid;'>
                    <div class={`${style.pointerCursor} nav-link py-0 ${isSelected ? 'active' : ''}`}>
                        <span onClick={() => this.onClickTag(null, { open: true })}>
                            ALL TAGS
                        </span>
                    </div>
                </div>

                <div class='mb-4 pb-4' style='border-bottom: 1px solid;'>
                    PINNED TAGS: <br />
                    <TagList
                        className={'font-weight-bold'}
                        tags={tagTreeBranchPinned}
                        queryFilter={queryFilter}
                        onClickTag={this.onClickTag}
                    />
                </div>

                <TagList
                    tags={tagTree}
                    queryFilter={queryFilter}
                    onClickTag={this.onClickTag}
                    children={tagTreeBranch}
                    parent={tagTreeParent}
                />
            </div>
        );
    }
}

export default TagTree;



// WEBPACK FOOTER //
// ./components/articles/tree.js